import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import queryFn from "ApiLayer/Properties/queryProperty";
import { QUERY_STALE_TIME } from "utils/constants";

export const useProperty = (propertyUid: string | undefined) => {
    const accessToken = useAccessToken();
    return useQuery({
        queryKey: ["property", propertyUid],
        queryFn: async () => queryFn(accessToken, propertyUid!),
        staleTime: QUERY_STALE_TIME,
        enabled: !!propertyUid,
    });
};
